<!-- Main Section: Scheme List - Tailwind Only -->
<section *ngIf="!viewDetails">
  <div class="max-w-7xl mx-auto px-4 py-4 bg-slate-50 rounded border-2 border-slate-200">
    <div class="border-b border-slate-200 pb-2 mb-3">
      <h2 class="text-2xl font-bold text-primary-800">Idex Scheme</h2>
    </div>
    <div class="flex flex-wrap gap-6">
      <div
        *ngFor="let scheme of schemes"
        class="flex flex-col w-full sm:w-[48%] md:w-[30%] lg:w-[22%] rounded border-2 shadow-md border-blue-100 bg-white p-6 transition-all">
        <div class="flex items-center gap-2 mb-3">
          <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-700 border border-red-300">
            {{ scheme.code }}
          </span>
        </div>
        <h4 class="font-semibold text-blue-800 text-lg mb-2">{{ scheme.name }} SCHEME</h4>
        <div class="text-sm text-slate-600 truncate mb-3" [pTooltip]="scheme.description" tooltipPosition="top">
          {{ scheme.description }}
        </div>
        <button
          class="mt-auto w-full bg-gradient-to-r from-blue-400 to-blue-700 text-white font-semibold py-2 rounded hover:from-blue-600 hover:to-blue-800 transition"
          (click)="selectScheme(scheme)">
          View Challenges <i class="pi pi-arrow-right ml-2"></i>
        </button>
      </div>
    </div>
  </div>
</section>

<div *ngIf="viewDetails" class="max-w-7xl mx-auto px-4 py-2 bg-white rounded-sm shadow-sm ring-1 ring-gray-900/5">
  <div class="border-b border-slate-200 pb-1 mb-3 flex items-center justify-between">
    <h2 class="text-2xl **sm:text-3xl** font-extrabold text-gray-900" *ngIf="selectedSchemeName">{{ selectedSchemeName }}</h2>
  <button
    class="inline-flex items-center px-4 py-2 text-sm bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-lg transition mb-4"
    (click)="viewDetails = false"
  >
    <i class="pi pi-arrow-left mr-2"></i>
    Back to Schemes
  </button>
  </div>
  
  <div>
    <div class="flex items-center justify-between w-full mb-4">
      <div class="flex flex-nowrap items-center gap-1 bg-slate-200 p-1 rounded-xl border border-slate-500 shadow-sm overflow-x-auto" >
        <button *ngFor="let tab of proposalStatusTabs"
          class="flex items-center justify-start gap-2 px-2.5 py-2.5 rounded-xl text-xs font-bold transition-all duration-200 whitespace-nowrap min-w-fit outline-none"
          [ngClass]="activeStatusTabIndex.status === tab.status 
            ? 'bg-slate-800 text-white shadow-md ring-1 ring-slate-300' 
            : 'text-slate-700 hover:text-white hover:bg-slate-600/70'"
          (click)="onProposalStatusTabChange(tab)">
          
          <span class="w-2 h-4 rounded-2xl" 
            [ngClass]="{
              'bg-gray-600': tab.status === 'form',
              'bg-blue-700': tab.status === 'initiated',
              'bg-amber-700': tab.status === 'in_review',
              'bg-emerald-700': tab.status === 'approved',
              'bg-slate-700': tab.status === 'short_close',
              'bg-red-700': tab.status === 'rejected',
              'bg-yellow-700': tab.status === 'project_bank',
              'bg-green-700': tab.status === 'oc_version',
            }">
          </span>
      
          {{ tab.label }}
        </button>
      </div>
      </div>
    
    <div *ngIf="activeStatusTabIndex.tab === 0" class="**space-y-6**">
      <div *ngIf="selectedScheme.id != 7">
          <app-idex-from [title]="'Create New Challenge'" [subScheme]="selectedScheme" (submitProposal)="submitProposal($event)"></app-idex-from>
      </div>
      <div *ngIf="selectedScheme.id == 7">
          <app-oc-proposal-upload [title]="'Upload OC Proposal'" [stepDetails]="'create'" [subScheme]="selectedScheme"></app-oc-proposal-upload>
      </div>
    </div>
    
    <div *ngIf="activeStatusTabIndex.tab === 1 || activeStatusTabIndex.tab === 2" class="bg-amber-50 p-3 rounded shadow-sm mt-6">
      
      <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
        <span class="text-2xl font-bold text-gray-700">{{ activeStatusTabIndex.label }}</span>
        
        <div class="flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-4">
          
          <div class="flex gap-2">
            <button
              *ngIf="activeStatusTabIndex.status === 'project_bank'"
              (click)="showCustomInputPopup=true"
              [disabled]="selectedProposals.length === 0"
              type="button"
              class="inline-flex items-center gap-2 px-3 py-1 text-sm font-semibold rounded shadow-md border-2 border-green-600 bg-green-100 text-green-700 hover:bg-green-500  hover:text-white  transition "
            >
              <span class="flex items-center justify-center">
                <i class="pi pi-check-circle text-lg text-green-600"></i>
              </span>
              <span>Launch</span>
            </button>
            <button
              (click)="clear(dt, searchInput)"
              type="button"
              class="inline-flex items-center gap-2 px-3 py-1 text-sm font-semibold rounded shadow-md border-2 border-purple-500 bg-purple-100 text-purple-700 hover:bg-purple-500  hover:text-white  transition "
            >
              <i class="pi pi-filter-slash mr-2 text-purple-700"></i>
              Clear Filters
            </button>
          </div>
          
          <div class="relative w-full md:w-[300px]">
            <i class="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
            <input
              #searchInput
              pInputText
              type="text"
              [(ngModel)]="searchProposalQuery"
              (keyup.enter)="searchProposals(searchProposalQuery)"
              placeholder="Search across all records..."
              class="w-full border border-gray-300 rounded-lg pl-10 pr-4 py-2 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition text-gray-800 **shadow-sm**"
            />
          </div>
          
        </div>
      </div>
      
      <div>
        <p-table
          #dt
          [value]="proposalData"
          [paginator]="proposalData.length > 9"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[5, 10, 20, 50]"
          [lazy]="lazy"
          [totalRecords]="totalCount"
          (onPage)="onPageChange($event)"
          [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} entries'"
          [scrollable]="true"
          [(selection)]="selectedProposals"
          scrollDirection="both"
          [resizableColumns]="true"
          [reorderableColumns]="true"
          [globalFilterFields]="['name','description','proposal_status','created_by.first_name','created_by.last_name']"
          dataKey="id"
          class="text-sm **border border-gray-200 rounded-xl overflow-hidden**"
        >
          <ng-template pTemplate="header">
            <tr>
              <ng-container *ngFor="let column of tableColumns">
                <th
                  (click)="lazy=false"
                  [pSortableColumn]="column.field"
                  pResizableColumn
                  
                >
                  <ng-container [ngSwitch]="column.field">
                    <ng-container *ngSwitchCase="'checkbox'">
                      <p-tableHeaderCheckbox class="**flex justify-center**"></p-tableHeaderCheckbox>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <span>{{ column.header }}</span>
                    </ng-container>
                  </ng-container>
                  <p-columnFilter  *ngIf="column.filter"  class="text-gray-600" [type]="'text'" [field]="column.field" display="menu" [showMatchModes]="true" [showOperator]="false" [showAddButton]="false"></p-columnFilter>

            
                </th>
              </ng-container>
              <th *ngIf="activeStatusTabIndex.tab !== 2"  pFrozenColumn alignFrozen="right"
                class="px-4 py-2 bg-blue-100 text-blue-900 font-semibold border-b border-blue-200 whitespace-nowrap">
                Actions
          </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-proposal>
            <tr class="hover:bg-indigo-50/50 **border-b border-gray-100**">
              <ng-container *ngFor="let column of tableColumns">
                <td class="py-3 px-3">
                  <ng-container [ngSwitch]="column.field">
                    <ng-container *ngSwitchCase="'checkbox'">
                      <p-tableCheckbox [value]="proposal" selectionMode="multiple" class="**flex justify-center**"></p-tableCheckbox>
                    </ng-container>
                    <ng-container *ngSwitchCase="'name'">
                      <span
                        class="text-indigo-600 font-medium cursor-pointer hover:text-indigo-800 hover:underline"
                        pTooltip="{{ proposal.name }}"
                        (click)="navigateToSchemeTransaction(proposal, activePhaseId)"
                      >
                        {{ proposal.name }}
                      </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'description'">
                      <span class="text-gray-500 max-w-xs truncate inline-block" [pTooltip]="proposal.description">
                        {{ proposal.description }}
                      </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'steps'">
                      <span class="inline-flex items-center px-3 py-1 rounded-full bg-indigo-50 text-indigo-700 text-xs font-medium border border-indigo-200">
                        {{ proposal.step_summary?.completed_steps || 0 }}/{{ proposal.step_summary?.total_steps || 0 }}
                      </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'progress'">
                      <div class="flex items-center gap-2">
                          <div class="w-[90px] h-2 rounded-full bg-gray-200 overflow-hidden">
                              <div
                                  class="h-2 bg-teal-500 rounded-full transition-all"
                                  [style.width.%]="proposal.step_summary?.completed_percentage || 0"
                              ></div>
                          </div>
                          <span class="text-xs text-gray-500 font-medium">{{ proposal.step_summary?.completed_percentage || 0 }}%</span>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'created_by'">
                      <i class="pi pi-user text-gray-400 mr-2"></i>
                      {{ proposal.created_by?.first_name }} {{ proposal.created_by?.last_name }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'directorate'">
                      <i class="pi pi-building text-gray-400 mr-2"></i>
                      {{ proposal.created_by?.unit?.name }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'proposal_status'">
                      <span
                        [ngClass]="getStatusBadgeClass(proposal.proposal_status)"
                        class="inline-block rounded-full px-3 py-1 text-xs font-semibold **tracking-wide**"
                      >
                        {{ proposal.proposal_status | titlecase }}
                      </span>
                    </ng-container>
                    
                    <ng-container *ngSwitchDefault>
                      {{ getFieldValue(proposal, column.field) || '-' }}
                    </ng-container>
                  </ng-container>
                </td>
              </ng-container>
              <td *ngIf="activeStatusTabIndex.tab !== 2" pFrozenColumn alignFrozen="right"
              class="align-middle px-4 py-2 border-b border-gray-100 whitespace-nowrap">
              
              <button
                class="border-2 border-red-400 bg-red-100 text-red-700 font-bold px-2 py-1 rounded shadow-none text-base hover:border-red-500 hover:bg-red-200 transition-colors outline-none focus:outline-none"
                (click)="deleteProposal(proposal)" title="Delete">
                <i class="pi pi-trash"></i>
              </button>
            </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="tableColumns.length + 1" class="py-12 bg-gradient-to-r from-blue-50 to-teal-50">
                <div class="flex flex-col items-center justify-center gap-3">
                  <div class="flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-2 shadow">
                    <i class="pi pi-inbox text-3xl text-blue-400"></i>
                  </div>
                  <div class="text-xl font-semibold text-blue-800 mb-1">No Proposals Found</div>
                  <div class="text-gray-500 text-base">There are currently no proposals available for this phase or status.<br>Try changing filters or add a new proposal to get started!</div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      
      <ng-template #noData>
        <div class="bg-blue-50 text-blue-800 rounded-lg py-4 px-6 mt-8 text-center max-w-xl mx-auto text-base border border-blue-200">
          No proposals available for this phase.
        </div>
      </ng-template>
      
    </div>
  </div>
</div>

<!-- Proposal Card Template for List/Show -->
<ng-template #proposalCardTemplate let-proposal>
  <div class="flex flex-col bg-white rounded-xl shadow p-6 gap-4">
    <div class="flex items-center justify-between">
      <p-tag severity="info" [value]="proposal?.scheme?.name"></p-tag>
      <div class="flex gap-2">
        <span
          (click)="deleteProposal(proposal)"
          class="text-slate-700 hover:bg-slate-100 p-2 rounded cursor-pointer"
          pTooltip="Delete Proposal"
          tooltipPosition="top"
          *ngIf="('/master/proposal' | hasPermission : 'Delete') || proposal.can_edit == true"
        >
          <i class="pi pi-trash text-red-600"></i>
        </span>
        <span
          (click)="updateProposal(proposal)"
          class="text-slate-700 hover:bg-slate-100 p-2 rounded cursor-pointer"
          pTooltip="Edit Proposal"
          tooltipPosition="top"
          *ngIf="('/master/proposal' | hasPermission : 'Edit') || proposal.can_edit == true"
        >
          <i class="pi pi-pencil"></i>
        </span>
        <span
          (click)="navigateToSchemeTransaction(proposal, activePhaseId)"
          class="text-slate-700 hover:bg-slate-100 p-2 rounded cursor-pointer"
          pTooltip="Go to Steps"
          tooltipPosition="top"
          *ngIf="'/master/proposal' | hasPermission : 'View'"
        >
          <i class="pi pi-arrow-right"></i>
        </span>
      </div>
    </div>
    <div>
      <h5 class="font-bold text-blue-800 mb-1">{{ proposal?.name }}</h5>
      <div class="text-slate-500 text-sm truncate" [pTooltip]="proposal.description" tooltipPosition="top">
        {{ proposal.description }}
      </div>
    </div>
    <div class="flex justify-between text-xs text-slate-400">
      <span>Step {{ proposal.step_summary.completed_steps || 0 }}/{{ proposal.step_summary.total_steps || 0 }}</span>
      <span>{{ proposal.step_summary.completed_percentage }}% Complete</span>
    </div>
    <div class="w-full h-2 rounded bg-slate-200 mb-1">
      <div
        class="h-2 bg-blue-600 rounded transition-all"
        [style.width.%]="proposal.step_summary.completed_percentage"
      ></div>
    </div>
    <div class="flex justify-between items-center text-xs text-slate-500">
      <div class="flex items-center">
        <i class="pi pi-clock mr-2"></i>
        Created {{ proposal.created_on | date : "dd-MM-yyyy" }}
      </div>
      <p-tag [value]="proposal.proposal_status | uppercase" severity="success" rounded></p-tag>
    </div>
    <button
      class="w-full mt-2 bg-gradient-to-r from-blue-400 to-blue-700 text-white font-semibold py-2 rounded hover:from-blue-600 hover:to-blue-800 transition"
      (click)="navigateToScheme(proposal)">
      View Details
    </button>
  </div>
</ng-template>

<!-- Delete Proposal Dialog -->
<ng-container *ngIf="isDeleteProposal">
  <p-dialog
    header="Delete Proposal"
    [modal]="true"
    [(visible)]="isDeleteProposal"
    [style]="{ width: '24rem' }"
    [maximizable]="true"
  >
    <div class="flex flex-col gap-4 p-1 pb-2">
      <span class="text-lg text-slate-800">
        Are you sure you want to delete <span class="font-semibold">{{ selectedProposal.name }}</span> proposal?
      </span>
      <p-button
        label="Delete"
        icon="pi pi-trash"
        severity="danger"
        [outlined]="true"
        (click)="confirmDelete()"
      ></p-button>
    </div>
  </p-dialog>
</ng-container>

<ng-container *ngIf="displayDialogN">
  <app-scheme-wise-route-popup [displayDialog]="displayDialogN" (closeDialog)="displayDialogN = false" (onSubmit)="onNeedformSubmit($event)" ></app-scheme-wise-route-popup>
</ng-container>

<!-- Simple Tailwind popup with input box -->
<div *ngIf="showCustomInputPopup" class="fixed inset-0 flex items-center justify-center z-50  backdrop-blur-sm">
  <div class="bg-white rounded-lg shadow-lg w-full max-w-xs p-6 relative">
    <button 
      class="absolute top-2 right-2 text-gray-400 hover:text-gray-700"
      (click)="showCustomInputPopup = false"
      aria-label="Close"
    >
      <i class="pi pi-times"></i>
    </button>
    <h3 class="text-lg font-semibold mb-4 text-gray-800">Enter Launch Version</h3>
    <input 
      type="text" 
      [(ngModel)]="customPopupInput.version"
      class="w-full border border-gray-300 rounded-md py-2 px-3 focus:ring-2 focus:ring-blue-500 outline-none text-gray-800 mb-4"
      placeholder="Type here..."
    />
    <input 
      type="date" 
      [(ngModel)]="customPopupInput.date"
      class="w-full border border-gray-300 rounded-md py-2 px-3 focus:ring-2 focus:ring-blue-500 outline-none text-gray-800 mb-4"
      placeholder="Type here..."
    />
    <div class="flex justify-end gap-2">
      <button 
        class="bg-gray-200 text-gray-700 rounded px-4 py-2 hover:bg-gray-300"
        (click)="showCustomInputPopup = false"
      >
        Cancel
      </button>
      <button 
        class="bg-blue-600 text-white rounded px-4 py-2 hover:bg-blue-700"
        (click)="onCustomInputSubmit()"
      >
        Submit
      </button>
    </div>
  </div>
</div>

